import { supabase } from '../lib/supabase';
import {
  AdminUpdateApplicationStatusRequest,
  AdminUpdateApplicationStatusResponse,
} from '../types';

/**
 * 관리자: 신청 상태 변경 (waiting→registered, →cancelled 등)
 */
export const adminUpdateApplicationStatus = async (
  request: AdminUpdateApplicationStatusRequest
): Promise<AdminUpdateApplicationStatusResponse> => {
  try {
    console.log('Admin update application status request:', request);

    // Get auth token
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;

    if (!token) {
      return {
        success: false,
        error: {
          code: 'UNAUTHORIZED',
          message: '로그인이 필요합니다.',
        },
      };
    }

    // Call Edge Function
    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
    const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

    const response = await fetch(`${supabaseUrl}/functions/v1/admin-update-application-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'apikey': supabaseAnonKey,
      },
      body: JSON.stringify(request),
    });

    const responseData = await response.json();
    console.log('Admin update application status response:', { status: response.status, data: responseData });

    return responseData;
  } catch (error: any) {
    console.error('Admin update application status error:', error);
    return {
      success: false,
      error: {
        code: 'UNEXPECTED_ERROR',
        message: '예상치 못한 오류가 발생했습니다.',
        details: error.message,
      },
    };
  }
};
